import React from "react";
import { Outlet } from "react-router-dom";
import { useTenant } from "../TenantContext";
import BootstrapErrorPage from "./BootstrapErrorPage";

/**
 * Do not render the authenticated application shell until GET /me/tenant
 * has resolved. Fail closed on bootstrap errors.
 */
export default function TenantBootstrapGate() {
  const { status, isReady } = useTenant();

  if (status === "loading" || status === "idle") {
    return (
      <div style={{ padding: 32 }} data-testid="tenant-bootstrap-loading">
        Loading your Master Account…
      </div>
    );
  }

  if (status === "error" || !isReady) {
    return <BootstrapErrorPage />;
  }

  return <Outlet />;
}
